export default class InteractiveMap {
    constructor(mapElementId, showOnlyStatus) {
        this.stationStatuses = {
            "VACANCIES": "vacancies",
            "JOBBANK": "jobbank",
            "CLOSED": "closed",
        };
        this.stationEmployment = {
            "PART_TIME": "Deltidsansat på timeløn",
            "FULL_TIME": "Fuldtidsansat",
            "VOLUNTARY": "Frivillig i et stærkt fællesskab",
        };
        this.icons = {
            'user': '/images/bbn/icons/map/marker-icon-home.png',
            'inactive': '/images/bbn/icons/map/inactive-marker.png',
            'active': '/images/bbn/icons/map/active-marker.png',
        }

        this.showOnlyStatus = showOnlyStatus;
        this.geoCoder = new google.maps.Geocoder();
        this.map = this.initMap(mapElementId);
        this.initSearchForm();
        this.loadStations();
    }

    initMap(mapElementId) {
        this.userMarker();
        this.paramAddressFocus();

        let startPosition = {lat: 56.2913, lng: 10.8898}; // Middle of Denmark
        return new google.maps.Map(document.getElementById(mapElementId), {
            zoom: 8,
            center: startPosition,
            fullscreenControl: false,
            mapId: 'adfe9a5876c1d72d',
            disableDefaultUI: true,
        });
    }

    initSearchForm() {
        const searchStationButton = document.querySelector('[data-js-map-search-button]');
        const searchStationInput = document.querySelector('[data-js-map-search-input]');

        if (searchStationButton && searchStationInput) {
            searchStationButton.addEventListener('click', (e) => {
                e.preventDefault();
                const address = searchStationInput.value + ', Denmark';
                if (address) {
                    this.geoCoder.geocode({ 'address': address }, (results, status) => {
                        if (status === 'OK') {
                            this.map.setCenter(results[0].geometry.location);
                            this.map.setZoom(11);
                        }
                    });
                }
            });

            searchStationInput.addEventListener('keydown', (e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    searchStationButton.click();
                }
            });
        }

    }

    addMarker(position, icon, data) {
        const data_url = data && typeof data.url !== 'undefined' ? data.url : '';

        const marker = new google.maps.Marker({
            position: position,
            map: this.map,
            icon: icon,
            url: data_url,
            title: data ? data.name : undefined
        });
        if (data) {
            google.maps.event.addListener(marker, 'click', () => {
                window.open(marker.url);
            })
        }
    }

    createStationMarkers(stations) {
        if (stations.data) {
            stations.data.forEach((station) => {
                if (this.showOnlyStatus === null || this.showOnlyStatus === station.active_campaign) {
                    if (station.address.latitude !== "" && station.address.longitude !== "") {
                        this.addMarker(
                            {
                                lat: station.address.latitude,
                                lng: station.address.longitude
                            },
                            this.statusIcon(station.active_campaign),
                            station
                        );
                    } else {
                        this.geoCoder.geocode({'address': station.address.address + ', ' + station.address.city}, (results, status) => {
                            if (status === 'OK') {
                                this.addMarker(results[0].geometry.location, this.statusIcon(station.active_campaign), station);
                            }
                        })
                    }
                }
            });
        }
    }

    loadStations() {
        // Load stations
        fetch('/api/firestations')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                this.createStationMarkers(data);
            })
            .catch(error => {
                console.error('There was a problem with the fetch operation:', error);
            });
    }

    userMarker() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const center = {lat: position.coords.latitude, lng: position.coords.longitude};
                this.addMarker(center, this.icons.user);
                // Also render a circle around the home marker
                new google.maps.Circle({
                    fillColor: '#fecc00',
                    fillOpacity: '0.48',
                    map: this.map,
                    center: center,
                    radius: 3000, // meters
                    strokeWeight: 0
                })
            });
        }
    }

    paramAddressFocus() {
        const params = new URLSearchParams(window.location.search);
        const address = params.get('address') + ', Denmark';

        if (params.get('address') !== null) {
            this.geoCoder.geocode({'address': address}, (results, status) => {
                if(status === 'OK') {
                    this.map.setCenter(results[0].geometry.location);
                    this.map.setZoom(12);
                }
            })
        }
    }

    statusIcon = (status) => {
        switch (status) {
            case this.stationStatuses.CLOSED:
                return this.icons.inactive;
            case this.stationStatuses.JOBBANK:
            case this.stationStatuses.VACANCIES:
                return this.icons.active;
        }
    };
}

window.initMap = function() {
    new InteractiveMap('js-map', null);
}

window.initWaitMap = function() {
    new InteractiveMap('js-map-waitlist', 'closed');
}

window.initActiveMap = function() {
    new InteractiveMap('js-map-actives', 'vacancies');
}
